import { normalize, schema } from 'normalizr';

export const entity = 'vendorReturnItem';

export const endpoints = {
  list: ({
    vendorReturnID,
    includeSN = false,
    page: { size = 50, number = 1 } = {},
    sort = '',
    filter: { query = '' } = {},
  }) => ({
    url: `/admin/vendor-returns/${vendorReturnID}/items?page[size]=${size}&page[number]=${number}&sort=${sort}&filter[query]=${query}&include=${
      includeSN ? 'Item,Reason,Taxes,SerialNumbers' : 'Item,Reason,Taxes'
    }`,
    entity,
    list: true,
  }),
  edit: ({ vendorReturnID, includeSN = false, itemID, payload, onSuccess }) => ({
    url: `/admin/vendor-returns/${vendorReturnID}/items/${itemID}?include=${
      includeSN ? 'Item,Reason,Taxes,SerialNumbers' : 'Item,Reason,Taxes'
    }`,
    payload,
    entity,
    list: false,
    onSuccess,
  }),
  delete: ({ vendorReturnID, itemID = '', payload, onSuccess }) => ({
    url: `/admin/vendor-returns/${vendorReturnID}/items/${itemID}`,
    payload,
    entity,
    list: false,
    onSuccess,
  }),
};
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'vendorReturnItemID',
  }
);
export const normalizer = (result) => normalize(result, entitySchema);
export const listNormalizer = (result) => normalize(result, [entitySchema]);
